export default __webpack_public_path__ + "static/media/download-black.51554f09.svg";